import type { DBConversationResponse } from '@/types/api';
import { Collapsible } from '@/components/ui/collapsible';
import { ConversationHeader } from './ConversationHeader';
import { ConversationTranscript } from './ConversationTranscript';

export interface ConversationItemProps {
  conversation: DBConversationResponse;
}

export const ConversationItem = ({ conversation }: ConversationItemProps) => {
  const transcript = conversation.transcript ?? [];
  const recordingLink = conversation.videoRecordingUrl;
  const createdAt = conversation.createdAt;

  return (
    <Collapsible className='flex flex-col gap-2 border rounded-lg p-2'>
      <ConversationHeader
        messageCount={transcript.length}
        recordingLink={recordingLink}
        createdAt={createdAt}
      />
      <ConversationTranscript transcript={transcript} />
    </Collapsible>
  );
};
